import { render, staticRenderFns } from "./voicedisable.vue?vue&type=template&id=3f60d425&"
import script from "./voicedisable.vue?vue&type=script&lang=js&"
export * from "./voicedisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports